import styled from "@emotion/styled";
import { Column, Row } from "@src/components/Flex";
import SizedBox from "@components/SizedBox";
import Text from "@components/Text";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "@stores/AccountStore";
import { ReactComponent as Logo } from "@assets/images/bigLogo.svg";
import LanguageSelectTooltip from "@components/LanguageSelectTooltip";
import { observer } from "mobx-react-lite";
import { MOBILE_BREAKPOINT } from "@src/hooks/useIsMobile";

interface IProps {
}

const Root = styled(Row)`
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  @media (min-width: ${MOBILE_BREAKPOINT + 1}px) {
    min-width: 1152px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    min-height: 100dvh;
    padding: 16px;
    box-sizing: border-box;
  }
`;

const LogoWrapper = styled(Column)`
  box-sizing: border-box;
  max-width: fit-content;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    max-width: 100%;
    svg {
      width: 100%;
      height: auto;
    }
  }
`;

export const ErrorAlert = styled.div<{ enabled: boolean }>`
  font-family: Nunito Sans, sans-serif;
  font-weight: bold;
  font-size: 11px;
  line-height: 18px;
  letter-spacing: 0.65px;
  text-transform: uppercase;
  color: #ffffff;
  transition: 0.4s;
  height: ${({ enabled }) => (enabled ? "32px" : 0)};
  padding: ${({ enabled }) => (enabled ? "7px 16px" : "0 16px")};
  margin-bottom: ${({ enabled }) => (enabled ? "8px" : 0)};
  background: #d82a35;
  border-radius: 4px;
  align-items: center;
  box-sizing: border-box;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 336px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 100%;
    max-width: 336px;
  }
`;

const AuthLayout: React.FC<IProps> = ({ children }) => {
  const location = useLocation();

  const allowedRoutes = [
    ROUTES.LOGIN,
    ROUTES.REGISTER,
    ROUTES.VERIFY_EMAIL,
    ROUTES.PASSWORD_RESET,
    ROUTES.PASSWORD_FORGOT,
    ROUTES.OAUTH_CONSENT,
  ];

  if (!allowedRoutes.includes(location.pathname as ROUTES)) {
    return Navigate({ to: ROUTES.LOGIN });
  }

  return (
    <Root>
      <LogoWrapper justifyContent="center" crossAxisSize="max">
        <Logo />
      </LogoWrapper>
      <Column>
        <SizedBox height={32} />
        <Row>{children}</Row>
        <SizedBox height={64} />
        <Row>
          <Text color="#899093" size={10} fitContent>
            © {new Date().getFullYear()}, Green Growth
          </Text>
          <SizedBox width={16} />
          <LanguageSelectTooltip />
        </Row>
      </Column>
    </Root>
  );
};

export default observer(AuthLayout);
